/** Display timestamps the same way Hub does: Malaysia civil time. */

export function stamp(value: string): string {
	if (!value) return "";
	const raw = value.includes("T") ? value : value.replace(" ", "T");
	const date = new Date(/Z$|[+-]\d{2}:\d{2}$/.test(raw) ? raw : `${raw}+08:00`);
	if (Number.isNaN(date.getTime())) return value;
	return new Intl.DateTimeFormat("en-GB", {
		timeZone: "Asia/Kuala_Lumpur",
		day: "2-digit",
		month: "short",
		hour: "2-digit",
		minute: "2-digit",
		hour12: false,
	}).format(date);
}

export function isoDay(value: string | Date): string {
	const date = typeof value === "string" ? new Date(value) : value;
	if (Number.isNaN(date.getTime())) return "";
	const parts = new Intl.DateTimeFormat("en-CA", {
		timeZone: "Asia/Kuala_Lumpur",
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
	}).formatToParts(date);
	const year = parts.find((part) => part.type === "year")?.value;
	const month = parts.find((part) => part.type === "month")?.value;
	const day = parts.find((part) => part.type === "day")?.value;
	return year && month && day ? `${year}-${month}-${day}` : "";
}

export function titleCase(value: string): string {
	if (!value) return value;
	return value.slice(0, 1).toUpperCase() + value.slice(1);
}

const LABELS: Record<string, string> = {
	facebook: "Facebook",
	instagram: "Instagram",
	"instagram-standalone": "Instagram",
	threads: "Threads",
	x: "X",
	linkedin: "LinkedIn",
	"linkedin-page": "LinkedIn Page",
	tiktok: "TikTok",
	whatsapp: "WhatsApp",
	telegram: "Telegram",
	messenger: "Messenger",
	signal: "Signal",
	discord: "Discord",
	slack: "Slack",
	google_messages: "Google Messages",
	google_chat: "Google Chat",
	google_voice: "Google Voice",
	tumblr: "Tumblr",
	viber: "Viber",
	line: "LINE",
	channel: "Channel",
	direct: "Direct",
	inbound: "Customer",
	outbound: "You",
	draft: "Draft",
	scheduled: "Scheduled",
	publishing: "Publishing",
	published: "Published",
	failed: "Failed",
};

export function labelOf(value: string): string {
	return LABELS[value] ?? titleCase(value);
}
